// extracted by mini-css-extract-plugin
export default {"links":"PJoBLb9ldwGWPFSiJUqm"};